// extracted by mini-css-extract-plugin
export default {"button":"button__fQmKl","button__badge":"button__badge__2bTws","button__icon":"button__icon__2ZOvF","fade-in":"fade-in__3swVg","fade-out":"fade-out__eOEPb"};